import { AbstractApiService } from '../../services/abstract-service';

export class DashboardService extends AbstractApiService {
  public getDashboardInfoTable = async () => {
    const { data } = await this.api.get('/dashboard/table');

    return data;
  };
}
